import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Stack, styled, Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import type { To } from 'react-router'

import { ICONS, LinkUnstyled, unit } from '@hcr/ui'

import { Z_INDEX } from '../../../../../../../../libs/ui/src/lib/constants'

interface NavigationBackButtonProps {
  to: To
}

export const NavigationBackButton: FC<NavigationBackButtonProps> = ({ to }) => {
  const { t } = useTranslation()

  return (
    <ArrowLinkIcon to={to} aria-label={t('navigation.back')}>
      <Stack paddingX={unit(3)} paddingY={unit(2)} direction={'row'} alignItems={'center'}>
        <FontAwesomeIcon style={{ padding: unit(3) }} icon={ICONS.farArrowLeft} />
        <Typography component='span' variant='titleM'>
          {t('navigation.back')}
        </Typography>
      </Stack>
    </ArrowLinkIcon>
  )
}

const ArrowLinkIcon = styled(LinkUnstyled)`
  height: ${unit(16)};
  display: inline-flex;
  align-items: center;
  justify-content: start;
  position: relative;
  z-index: ${Z_INDEX.navigation};
  font-size: ${unit(6)};
  background-color: white;
  width: 100%;
`
